
import FbxButton from './fbx-button.vue';
import { PropType, defineComponent } from 'vue';
import CompanyLogo from './CompanyLogo.vue';
import ReturnOptions from '@/components/ReturnOptions.vue';
import { lockBodyScroll, unlockBodyScroll } from '@/shared/bodyScrollLock';

export default defineComponent({
    props: {
        titleText: String,
        subheadingText: String,
        subtitleText: String,
        footerText: String,
        acceptText: {
            type: String,
            default: 'Accept',
        },
        acceptDisabled: {
            type: Boolean,
            default: false,
        },
        rejectText: {
            type: String,
            default: 'Reject',
        },
        acceptTheme: {
            type: String,
            default: 'primary',
        },
        rejectDisabled: {
            type: Boolean,
            default: false,
        },
        rejectTheme: {
            type: String,
            default: 'return',
        },
        subtitleStyle: {
            type: String,
            default: 'subtitle-standard',
        },
        footerStyle: {
            type: String,
            default: 'bold',
        },
        popupStage: {
            type: Number,
            default: -1,
        },
        image: {
            type: String as PropType<string | null>,
            default: null,
        },
        confirmationLoading: {
            type: Boolean,
            default: false,
        },
        rejectionLoading: {
            type: Boolean,
            default: false,
        },
        fullScreen: {
            type: Boolean,
            default: false,
        },
        includeReturnDeepLink: {
            type: Boolean,
            default: true,
        },
        forceHideDeepLink: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        boldTitle: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        FbxButton,
        CompanyLogo,
        ReturnOptions,
    },
    methods: {
        acceptClicked(): void {
            if (this.popupStage === 1) {
                this.$emit('confirmStage', { didAccept: true });
                return;
            }

            this.$emit('accept', { didAccept: true });
        },
        rejectClicked(): void {
            if (this.popupStage === 1) {
                this.$emit('confirmStage', { didAccept: false });
                return;
            }

            this.$emit('reject', { didAccept: false });
        },
    },
    created(): void {
        (document.activeElement as HTMLElement).blur();
    },
    beforeMount() {
        lockBodyScroll();
    },
    beforeUnmount() {
        unlockBodyScroll();
    },
});
